import { __assign } from "tslib";
import { MediaManagerUploadErrorTypes } from './uploadTypes';
import { MediaUploadErrorKey } from 'wix-rich-content-common';
export var getUploadError = function (error, metaSiteId, isOwner) {
    var _a;
    var upgradeUrl = "https://www.wix.com/store/plans?siteGuid=".concat(metaSiteId);
    var _b = error.error_info || {}, key = _b.key, args = _b.args;
    var errorMessages = (_a = {},
        _a[MediaManagerUploadErrorTypes.SizeLimitExceeded] = {
            key: MediaUploadErrorKey.SIZE_LIMIT,
            args: { maxLimit: parseInt(args === null || args === void 0 ? void 0 : args[1], 10) },
        },
        _a[MediaManagerUploadErrorTypes.SiteQuotaExceeded] = {
            key: isOwner
                ? MediaUploadErrorKey.QUOTA_STORAGE_OWNER
                : MediaUploadErrorKey.QUOTA_STORAGE_VISITOR,
            args: { upgradeUrl: upgradeUrl, usage: args === null || args === void 0 ? void 0 : args[0], limit: args === null || args === void 0 ? void 0 : args[1] },
        },
        _a[MediaManagerUploadErrorTypes.SiteVideoDurationQuotaExceeded] = {
            key: isOwner
                ? MediaUploadErrorKey.QUOTA_VIDEO_OWNER
                : MediaUploadErrorKey.QUOTA_VIDEO_VISITOR,
            args: { upgradeUrl: upgradeUrl, usage: args === null || args === void 0 ? void 0 : args[0], limit: args === null || args === void 0 ? void 0 : args[1] },
        },
        _a[MediaManagerUploadErrorTypes.SiteSingleVideoDurationQuotaExceeded] = {
            key: isOwner
                ? MediaUploadErrorKey.QUOTA_SINGLE_VIDEO_OWNER
                : MediaUploadErrorKey.QUOTA_SINGLE_VIDEO_VISITOR,
            args: { upgradeUrl: upgradeUrl, usage: args === null || args === void 0 ? void 0 : args[0], limit: args === null || args === void 0 ? void 0 : args[1] },
        },
        _a[MediaManagerUploadErrorTypes.General] = {
            key: MediaUploadErrorKey.GENERIC,
        },
        _a[MediaManagerUploadErrorTypes.MimeTypeMismatch] = {
            key: MediaUploadErrorKey.MIME_TYPE_MISMATCH,
        },
        _a[MediaManagerUploadErrorTypes.InvalidSession] = {
            key: MediaUploadErrorKey.INVALID_SESSION,
        },
        _a[MediaManagerUploadErrorTypes.SessionExpired] = {
            key: MediaUploadErrorKey.SESSION_EXPIRED,
        },
        _a[MediaManagerUploadErrorTypes.MissingWixSession] = {
            key: MediaUploadErrorKey.MISSING_WIX_SESSION,
        },
        _a[MediaManagerUploadErrorTypes.IncorrectFileInfo] = {
            key: MediaUploadErrorKey.INCORRECT_FILE_INFO,
        },
        _a[MediaManagerUploadErrorTypes.InvalidFile] = {
            key: MediaUploadErrorKey.CORRUPT_FILE,
        },
        _a[MediaManagerUploadErrorTypes.UnsupportedFileExtension] = {
            key: MediaUploadErrorKey.UNSUPPORTED_EXTENSION,
            args: { extension: args === null || args === void 0 ? void 0 : args[0] },
        },
        _a[MediaManagerUploadErrorTypes.WavInvalidMissingHeader] = {
            key: MediaUploadErrorKey.MISSING_HEADER,
        },
        _a[MediaManagerUploadErrorTypes.WavInvalidFormatChunkMissing] = {
            key: MediaUploadErrorKey.FORMAT_CHUNK_MISSING,
        },
        _a[MediaManagerUploadErrorTypes.ExternalFileAuthorization] = {
            key: MediaUploadErrorKey.EXT_FILE_AUTHORIZATION,
        },
        _a[MediaManagerUploadErrorTypes.ExternalFileForbidden] = {
            key: MediaUploadErrorKey.EXT_FILE_FORBBIDEN,
        },
        _a[MediaManagerUploadErrorTypes.UnsupportedImageFormat] = {
            key: MediaUploadErrorKey.IMAGE_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.CorruptedImage] = {
            key: MediaUploadErrorKey.CORRUPT_IMAGE,
        },
        _a[MediaManagerUploadErrorTypes.ImageDimentionsExceededLimit] = {
            key: MediaUploadErrorKey.IMAGE_DIMENSIONS_EXCEEDED,
        },
        _a[MediaManagerUploadErrorTypes.Mp4UnsupportedStereoOnly] = {
            key: MediaUploadErrorKey.MP4_STEREO_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.WavUnsupportedStereoOnly] = {
            key: MediaUploadErrorKey.WAV_STEREO_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.WmaUnsupportedBitrate] = {
            key: MediaUploadErrorKey.WMA_BITRATE,
        },
        _a[MediaManagerUploadErrorTypes.WmaUnsupportedBitrateLossy] = {
            key: MediaUploadErrorKey.WMA_BITRATE_LOSSY,
        },
        _a[MediaManagerUploadErrorTypes.Mp4UnsupportedBitrate] = {
            key: MediaUploadErrorKey.MP4_BITRATE,
        },
        _a[MediaManagerUploadErrorTypes.Mp3UnsupportedStereoOnly] = {
            key: MediaUploadErrorKey.MP3_UNSUPPORTED_STEREO,
        },
        _a[MediaManagerUploadErrorTypes.Mp3UnsupportedFormat] = {
            key: MediaUploadErrorKey.MP3_UNSUPPORTED_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.WavUnsupportedSampleRate] = {
            key: MediaUploadErrorKey.WAV_SAMPLE_RATE,
        },
        _a[MediaManagerUploadErrorTypes.AacUnsupportedFormat] = {
            key: MediaUploadErrorKey.AAC_UNSUPPORTED_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.WavUnsupportedFormat] = {
            key: MediaUploadErrorKey.WAV_UNSUPPORTED_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.WavUnsupportedSampleSize] = {
            key: MediaUploadErrorKey.WAV_SAMPLE_SIZE,
        },
        _a[MediaManagerUploadErrorTypes.WavUnsupportedFormatChunkSize] = {
            key: MediaUploadErrorKey.WAV_CHUNK_SIZE,
        },
        _a[MediaManagerUploadErrorTypes.UnsupportedAudioCodec] = {
            key: MediaUploadErrorKey.AUDIO_CODEC,
            args: { codec: args === null || args === void 0 ? void 0 : args[0] },
        },
        _a[MediaManagerUploadErrorTypes.ZeroSizeFile] = {
            key: MediaUploadErrorKey.EMPTY_FILE,
        },
        _a[MediaManagerUploadErrorTypes.Mp4UnsupportedFormat] = {
            key: MediaUploadErrorKey.MP4_UNSUPPORTED_FORMAT,
        },
        _a[MediaManagerUploadErrorTypes.Mp4UnsupportedSampleRate] = {
            key: MediaUploadErrorKey.MP4_SAMPLE_RATE,
        },
        _a[MediaManagerUploadErrorTypes.MaxVideoBitrateIsExceeded] = {
            key: MediaUploadErrorKey.VIDEO_BITRATE,
            args: { fps: args === null || args === void 0 ? void 0 : args[0] },
        },
        _a[MediaManagerUploadErrorTypes.VideoDurationMismatch] = {
            key: MediaUploadErrorKey.VIDEO_DURATION_MISMATCH,
            args: { videoDuration: args === null || args === void 0 ? void 0 : args[0], audioDuration: args === null || args === void 0 ? void 0 : args[1] },
        },
        _a[MediaManagerUploadErrorTypes.UnsupportedVideoCodec] = {
            key: MediaUploadErrorKey.VIDEO_CODEC,
            args: { codec: args === null || args === void 0 ? void 0 : args[0] },
        },
        _a);
    // If error key is not in handled error messages then the provided error message will be displayed
    var uploadError = errorMessages[key];
    return __assign({ msg: error.error_description }, uploadError);
};
//# sourceMappingURL=mediaErrorHandler.js.map